module.exports = __webpack_public_path__ + "img/CZ49241397.754fc864.png";